import { BaseAndCrudRoutes } from '@monorepo/tools/src/lib/routes/base.routes';

export class InventoryRoutes extends BaseAndCrudRoutes {
	constructor() {
		super('inventory');
	}
}
